import { render, staticRenderFns } from "./BatteryWarning.vue?vue&type=template&id=4f65ab7c"
import script from "./BatteryWarning.vue?vue&type=script&lang=js"
export * from "./BatteryWarning.vue?vue&type=script&lang=js"
import style0 from "./BatteryWarning.vue?vue&type=style&index=0&id=4f65ab7c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports